import { 
  PlayIcon,
  DocumentTextIcon,
} from '@heroicons/react/24/outline';
import React from 'react';

import { ProjectStatus } from '../../types/project';

interface ContinueButtonProps {
  projectId: number;
  projectStatus: ProjectStatus | string;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
}

export const MAIN_ACTION_BUTTON_CLASS_NAMES = [
  'inline-flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-colors',
  'bg-[#336094] text-white hover:bg-[#6e94c0]',
  'disabled:opacity-50 disabled:cursor-not-allowed',
  'focus:outline-none focus:ring-2 focus:ring-[#0097a9] focus:ring-offset-2',
  'main-button',
].join(' ');

/**
 * ContinueButton - Simple continue/open button that takes users to their current stage
 * No complex logic, just a straightforward action button
 */
export const ContinueButton: React.FC<ContinueButtonProps> = ({
  projectStatus,
  onClick,
  disabled = false,
  className = '',
}) => {
  // Simple logic: "Continue" for active projects, "Open" for completed
  // Handle both enum and string status types
  const isCompleted =
    projectStatus === ProjectStatus.COMPLETED ||
    projectStatus === ProjectStatus.PUBLISHED ||
    projectStatus === 'completed' ||
    projectStatus === 'published';
  const buttonText = isCompleted ? 'Open' : 'Continue';
  const ButtonIcon = isCompleted ? DocumentTextIcon : PlayIcon;

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={[
        MAIN_ACTION_BUTTON_CLASS_NAMES,
        className,
      ].join(' ')}
    >
      <ButtonIcon className="w-4 h-4" />
      {buttonText}
    </button>
  );
};
